<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  props: {
    show: Boolean,
    data: Object,
    mode: {
      type: String,
      default: "add",
    },
  },

  data() {
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      isLoading: false,
      isLoadingArea: false,
      isLoadingUnit: false,
      optionArea: [],
      optionUnit: [],
      form: {
        id_unitlev1: null,
        id_area: null,
        id_unit: null,
        nama_unitlev1: "",
        active_flag: 1,
      },
    };
  },

  watch: {
    modalShow(val) {
      if (val) {
        this.getArea();
        if (this.mode === "edit" && this.data) {
          this.form = {
            id_unitlev1: this.data.id_unitlev1,
            id_area: this.data.id_area,
            id_unit: this.data.id_unit,
            nama_unitlev1: this.data.nama_unitlev1 ?? "",
            active_flag: this.data.active_flag ?? 1,
          };
          if (this.form.id_area) this.getUnit(this.form.id_area);
        } else {
          this.resetForm();
        }
      } else {
        this.resetForm();
      }
    },
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },

  methods: {
    getArea() {
      this.isLoadingArea = true;
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master/area",
        params: { per_page: 200, column: "kode_area", dir: "asc" },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionArea = res.data?.data?.data ?? [];
        })
        .catch((err) => console.log("err get area:", err))
        .finally(() => {
          this.isLoadingArea = false;
        });
    },

    getUnit(id_area) {
      this.isLoadingUnit = true;
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master/unit",
        params: {
          per_page: 200,
          column: "nama_unit",
          dir: "asc",
          id_area,
        },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionUnit = res.data?.data?.data ?? [];
        })
        .catch((err) => console.log("err get unit:", err))
        .finally(() => {
          this.isLoadingUnit = false;
        });
    },

    onAreaChange(id_area) {
      this.form.id_unit = null;
      this.optionUnit = [];
      if (id_area) this.getUnit(id_area);
    },

    resetForm() {
      this.form = {
        id_unitlev1: null,
        id_area: null,
        id_unit: null,
        nama_unitlev1: "",
        active_flag: 1,
      };
      this.optionUnit = [];
    },

    store() {
      if (this.isLoading) return;

      if (!this.form.id_area) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "Area tidak boleh kosong.",
          showConfirmButton: true,
        });
        return;
      }

      if (!this.form.id_unit) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "Unit tidak boleh kosong.",
          showConfirmButton: true,
        });
        return;
      }

      if (!this.form.nama_unitlev1) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "Nama Unit Level 1 tidak boleh kosong.",
          showConfirmButton: true,
        });
        return;
      }

      const url =
        this.mode === "edit"
          ? this.BACKEND_URL_VERSION + "master/unit-lev1/" + this.form.id_unitlev1
          : this.BACKEND_URL_VERSION + "master/unit-lev1";

      const method = this.mode === "edit" ? "put" : "post";

      this.isLoading = true;
      axios({
        method,
        url,
        data: this.form,
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text:
              res.data?.meta?.message ||
              (this.mode === "edit"
                ? "Data berhasil diperbarui"
                : "Data berhasil disimpan"),
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          });

          this.$emit("close");
          this.$emit("finish");
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text:
              err.response?.data?.data ||
              err.response?.data?.meta?.message ||
              "Terjadi kesalahan.",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }, // end of store
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="mode === 'edit' ? 'Edit Unit Level 1' : 'Tambah Unit Level 1'"
    size="md"
    hide-footer
  >
    <b-form @submit.prevent="store">

      <b-form-group label="Area" class="fw-medium">
        <v-select
          :options="optionArea"
          :reduce="(item) => item.id_area"
          label="kode_area"
          v-model="form.id_area"
          :loading="isLoadingArea"
          :placeholder="isLoadingArea ? 'Memuat data...' : 'Pilih Area'"
          @input="onAreaChange"
        />
      </b-form-group>

      <b-form-group label="Unit" class="fw-medium">
        <v-select
          :options="optionUnit"
          :reduce="(item) => item.id_unit"
          label="nama_unit"
          v-model="form.id_unit"
          :loading="isLoadingUnit"
          :placeholder="isLoadingUnit ? 'Memuat data...' : 'Pilih Unit'"
          :disabled="!form.id_area || isLoadingUnit"
        />
      </b-form-group>

      <b-form-group label="Nama Unit Level 1" class="fw-medium">
        <b-form-input
          v-model="form.nama_unitlev1"
          type="text"
          placeholder="Masukkan Nama Unit Level 1"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Status" class="fw-medium">
        <select v-model="form.active_flag" class="form-control">
          <option :value="1">Aktif</option>
          <option :value="0">Tidak Aktif</option>
        </select>
      </b-form-group>

      <div class="text-end mt-3">
        <b-button variant="secondary" class="me-2" @click="$emit('close')">
          Batal
        </b-button>
        <b-button type="submit" variant="primary" :disabled="isLoading">
          <span v-if="isLoading">
            <i class="fa fa-spinner fa-spin me-1"></i> Menyimpan...
          </span>
          <span v-else>Simpan</span>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>
